module.exports = __webpack_public_path__ + "media/ringing_phone.0ea567b1.mp3";